import * as React from "react";
import { PrismicPreviewProvider } from "gatsby-plugin-prismic-previews";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AllCommunityModule } from "ag-grid-community";
import { AgGridProvider } from "ag-grid-react";
import "@egjs/flicking-plugins/dist/flicking-plugins.css";
import "react-loading-skeleton/dist/skeleton.css";
import "@stripe/stripe-js";
import { SkeletonTheme } from "react-loading-skeleton";

import "./src/styles/bs-carousel.css";
import "./src/styles/styles.css";
import "./src/styles/flicking.css";
import { configureAmplify } from "./src/config/amplify";
import { registerAuthQueryInvalidator } from "./src/utils/auth.utils";

configureAmplify();

require("typeface-inter");
require("@tailwindcss/custom-forms");

const queryClient = new QueryClient();
registerAuthQueryInvalidator(queryClient);

const modules = [AllCommunityModule];

const repositoryConfigs = [
  {
    repositoryName: "nzf2020"
  }
];

export const wrapRootElement = ({ element }) => (
  <PrismicPreviewProvider repositoryConfigs={repositoryConfigs}>
    <QueryClientProvider client={queryClient}>
      <AgGridProvider modules={modules}>
        <SkeletonTheme>{element}</SkeletonTheme>
      </AgGridProvider>
    </QueryClientProvider>
  </PrismicPreviewProvider>
);
